import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { http } from 'src/utils/axios'

const initialState = {
  properties: [],
  loading: true,
}

const fetchPropertiesSlice = createSlice({
  name: 'builder',
  initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPropertiesByBuilder.pending, (state) => {
      state.loading = true
    })
    builder.addCase(fetchPropertiesByBuilder.fulfilled, (state, action) => {
      state.loading = false
      state.properties = action.payload
    })
    builder.addCase(fetchPropertiesByBuilder.rejected, (state, action) => {
      state.loading = false
      state.properties = []
      console.log(action.payload)
    })
  },
})

export const fetchPropertiesByBuilder = createAsyncThunk(
  'builder/properties',
  async (body: any) => {
    const response = await http.post(`properties/properties_by_builder`, body)
    
    return response.data
  }
)

export default fetchPropertiesSlice.reducer;